import { create } from 'zustand'

/**
 * Tracker l'état actif/inactif de l'onglet courant.
 *
 * Un onglet devient "inactive" quand un autre onglet du même user prend le
 * relais via le canal BroadcastChannel `callizy-takeover` (cf.
 * useDashboardLifecycle). Le Device Twilio est détruit pour libérer le slot,
 * mais l'auth reste intacte — l'user peut "reprendre ici" pour recharger.
 *
 * Un onglet en appel ne cède pas : c'est le nouvel onglet qui devient inactif,
 * avec la raison `appel_ailleurs`.
 */
export type RaisonInactif = 'repris' | 'appel_ailleurs'

interface TabStateStore {
  isActive: boolean
  raison: RaisonInactif | null
  setInactive: (raison?: RaisonInactif) => void
  setActive: () => void
}

export const useTabStateStore = create<TabStateStore>((set) => ({
  isActive: true,
  raison: null,
  setInactive: (raison = 'repris') => set({ isActive: false, raison }),
  setActive: () => set({ isActive: true, raison: null }),
}))
